var map = {
	"./admin/admin.module": [
		"./src/app/admin/admin.module.ts"
	],
	"./admin/barcode/barcode.module": [
		"./src/app/admin/barcode/barcode.module.ts",
		"default~admin-barcode-barcode-module~admin-supplier-supplier-module",
		"common",
		"admin-barcode-barcode-module"
	],
	"./admin/customer/customer.module": [
		"./src/app/admin/customer/customer.module.ts",
		"common",
		"admin-customer-customer-module"
	],
	"./admin/invoice/invoice.module": [
		"./src/app/admin/invoice/invoice.module.ts",
		"default~admin-invoice-invoice-module~admin-parts-parts-module~admin-upload-upload-module~company-com~48539c78",
		"default~admin-invoice-invoice-module~admin-parts-parts-module~company-company-module",
		"default~admin-invoice-invoice-module~views-notifications-notifications-module",
		"common",
		"admin-invoice-invoice-module"
	],
	"./admin/order/order.module": [
		"./src/app/admin/order/order.module.ts",
		"common",
		"admin-order-order-module"
	],
	"./admin/parts/parts.module": [
		"./src/app/admin/parts/parts.module.ts",
		"default~admin-invoice-invoice-module~admin-parts-parts-module~admin-upload-upload-module~company-com~48539c78",
		"default~admin-invoice-invoice-module~admin-parts-parts-module~company-company-module",
		"default~admin-parts-parts-module~company-company-module",
		"common",
		"admin-parts-parts-module"
	],
	"./admin/supplier/supplier.module": [
		"./src/app/admin/supplier/supplier.module.ts",
		"default~admin-barcode-barcode-module~admin-supplier-supplier-module",
		"default~admin-supplier-supplier-module~usermanagement-usermanagement-module",
		"common",
		"admin-supplier-supplier-module"
	],
	"./admin/upload/upload.module": [
		"./src/app/admin/upload/upload.module.ts",
		"default~admin-invoice-invoice-module~admin-parts-parts-module~admin-upload-upload-module~company-com~48539c78",
		"common",
		"admin-upload-upload-module"
	],
	"./company/company.module": [
		"./src/app/company/company.module.ts",
		"default~admin-invoice-invoice-module~admin-parts-parts-module~admin-upload-upload-module~company-com~48539c78",
		"default~admin-invoice-invoice-module~admin-parts-parts-module~company-company-module",
		"default~admin-parts-parts-module~company-company-module",
		"common",
		"company-company-module"
	],
	"./reports/reports.module": [
		"./src/app/reports/reports.module.ts",
		"reports-reports-module"
	],
	"./usermanagement/usermanagement.module": [
		"./src/app/usermanagement/usermanagement.module.ts",
		"default~admin-supplier-supplier-module~usermanagement-usermanagement-module",
		"common",
		"usermanagement-usermanagement-module"
	],
	"./views/base/base.module": [
		"./src/app/views/base/base.module.ts",
		"views-base-base-module"
	],
	"./views/buttons/buttons.module": [
		"./src/app/views/buttons/buttons.module.ts",
		"views-buttons-buttons-module"
	],
	"./views/chartjs/chartjs.module": [
		"./src/app/views/chartjs/chartjs.module.ts",
		"views-chartjs-chartjs-module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"default~views-dashboard-dashboard-module~views-theme-theme-module~views-widgets-widgets-module",
		"common",
		"views-dashboard-dashboard-module"
	],
	"./views/icons/icons.module": [
		"./src/app/views/icons/icons.module.ts",
		"views-icons-icons-module"
	],
	"./views/notifications/notifications.module": [
		"./src/app/views/notifications/notifications.module.ts",
		"default~admin-invoice-invoice-module~views-notifications-notifications-module",
		"common",
		"views-notifications-notifications-module"
	],
	"./views/theme/theme.module": [
		"./src/app/views/theme/theme.module.ts",
		"default~views-dashboard-dashboard-module~views-theme-theme-module~views-widgets-widgets-module",
		"common",
		"views-theme-theme-module"
	],
	"./views/widgets/widgets.module": [
		"./src/app/views/widgets/widgets.module.ts",
		"default~views-dashboard-dashboard-module~views-theme-theme-module~views-widgets-widgets-module",
		"common",
		"views-widgets-widgets-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;